import React, { useContext, useEffect, useState } from 'react';
import 'antd/dist/antd.min.css';
import { Layout } from 'antd';
import { Outlet } from 'react-router-dom';
import DrawerMenu from '../menu/DrawerMenu';
import SideMenu from '../menu/SideMenu';
import Loader from '../loader/Loader';
import ProfileOptions from '../menu/ProfileOptions';
import GeneralContext from '../../../context/GeneralContext/GeneralContext';
import { SL_CountrySelector } from '../../../components/selects/SL_CountrySelector';
import api from '../../services/api';

const { Header, Content } = Layout;

const PatientInternalLayout = () => {
  const {
    mobile_mode,
    user,
    enums,
    setEnums,
    windowWidth,
    setShowLoading
  } = useContext(GeneralContext);
  
    useEffect(() => {
      if (!enums) {
        setShowLoading(true)
        
        api.auth.getEnums().then(
          rs => setEnums(rs.data)
        ).finally(
          () => setShowLoading(false)
        )
  
        return
      } 
    }, [enums])

  const isLandscapeOrMobileMode = windowWidth < 1000

  return (
    <Layout className="flex flex-row bg-white">
      <Loader />

      {mobile_mode || isLandscapeOrMobileMode ? <DrawerMenu /> : <SideMenu />}

      <Layout className="site-layout bg-white flex flex-col h-[100vh]">
        <Header
          style={{
            display: 'flex',
            height: mobile_mode || isLandscapeOrMobileMode ? 95 : '',
            background: 'white',
            padding: 0,
            borderBottom: '2px solid #1b3663',
            boxShadow: '0px -15px 39px #1b3663',
          }}
        >
          <div
            className={`flex flex-1 justify-between items-center flex-row ${mobile_mode || isLandscapeOrMobileMode && 'pb-10' }`}
          >
            <div
              className={`flex ${mobile_mode || isLandscapeOrMobileMode ? 'flex-col-reverse justify-between items-end' : 'flex-row justify-end items-center'} flex-1 ${user?.user_type_formatted?.id !== enums?.EUserTypes?.MONITOR?.code && 'mt-15'}`}
            >
              <ProfileOptions />
            </div>            
            <div className='flex p-2 justify-end flex-1 max-w-[40%]'>
                <SL_CountrySelector/>
            </div>
          </div>
        </Header>

        <Content
          className="site-layout-background mt-5 p-3 flex-1 overflow-auto"
        >
          <Outlet />
        </Content>
      </Layout>
    </Layout>
  );
};

export default PatientInternalLayout;
